//-------------------------------------------------------------------------------------------------- Includes
import { Card, Col, Row } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { ResponseMessages } from "../../../types/common";
import { RightOutlined } from "@ant-design/icons";
import MarkdownPreviewer from "../../../common/MarkdownPreviewer";
import _ from "lodash";
import InfoCardComponent from "../../../components/InfoCardComponent";
import moment from "moment";

//-------------------------------------------------------------------------------------------------- Interfaces
interface ListNotificationsComponentProps {
    notifications: Array<ResponseMessages>;
    onClickElement: Function;
};

//-------------------------------------------------------------------------------------------------- Component
const ListNotificationsComponent = (props: ListNotificationsComponentProps) => {
    const { notifications, onClickElement } = props;

    return (
        <Row style={styles.rowContainer}>
            {(_.isEmpty(notifications)) ? (
                <Col span={24}>
                    <InfoCardComponent title="¡Estimado usuario!" description="No hay mensajes para mostrar" />
                </Col>
            ) : (
                _.map(_.orderBy(notifications, 'date', 'desc'), (element, key) => (
                    <Col key={key} span={12} style={styles.mainContainer}>
                        <Card style={styles.cardStyle} onClick={() => onClickElement(element)}>
                            <Row style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <Col span={2}>
                                    {(!element.read) && (<div style={styles.dotStyle} />)}
                                </Col>
                                <Col span={20}>
                                    <Row>
                                        <Col span={24} style={(!element.read ? styles.readedStyle : styles.unreadedStyle)}>
                                            {moment(element.date).format("DD MMMM YYYY - H:mm")}
                                        </Col>
                                        <Col span={24}>
                                            <MarkdownPreviewer
                                                textStyle={{ color: "#707070", margin: 0 }}
                                                mdSource={element.title}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={2} style={styles.arrowContainer}>
                                    <RightOutlined />
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                ))
            )}
        </Row>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    rowContainer: {
        margin: "30px 0px 30px 0px",
    },
    mainContainer: {
        padding: 5,
    },
    cardStyle: {
        borderRadius: 20,
        boxShadow: "0px 0px 8px #00000029",
        cursor: 'pointer'
    },
    dotStyle: {
        width: 10,
        height: 10,
        background: "#0055b9",
        borderRadius: "50%"
    },
    readedStyle: {
        fontWeight: 600,
        color: "#0055b9",
    },
    unreadedStyle: {
        fontWeight: 600,
        color: "#000000",
    },
    arrowContainer: {
        display: "flex",
        justifyContent: "flex-end",
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default ListNotificationsComponent;
